import type { ReactNode } from "react";
import type {
	AbstractLeadFormProps,
	AbstractLeadFormState,
} from "@/component/assets/AbstractLeadForm/AbstractLeadForm";
import { AbstractLeadForm } from "@/component/assets/AbstractLeadForm/AbstractLeadForm";
import type { AbstractLeadFormFields, LeadRequest, ProductType } from "@/component/assets/AbstractLeadForm/types";
import type { EventComponentType } from "@/shared/lib/google-analytics-4.type";
import { logError } from "@/shared/lib/sentry-error";
import * as Step from "./Steps";
import type { PensionLeadCalcRequest, PensionLeadCalcResponse } from "./types";

export interface PensionSavingLeadFormFields extends AbstractLeadFormFields {}

export class PensionSavingLeadForm<
	TRequest extends PensionLeadCalcRequest,
	TResponse extends PensionLeadCalcResponse,
	TFormFields extends PensionSavingLeadFormFields,
	TProps extends AbstractLeadFormProps<TRequest, TResponse>,
	TState extends AbstractLeadFormState<TFormFields>,
> extends AbstractLeadForm<TRequest, TResponse, TFormFields, TProps, TState> {
	// EventParams
	protected readonly productTypes: string = "SAVINGS_INSURANCE";
	protected readonly componentType: EventComponentType = "leadform";

	public static defaultProps = {
		title: "Kérd részletes eredményeidet email-ben!",
	};

	protected renderSteps(): ReactNode {
		const {
			values: { email },
			submitState,
		} = this.state;

		return (
			<>
				<Step.LeadForm
					stepName="lead-form"
					submitState={submitState}
					defaultTarget="success-page"
					canStepBack
				/>
				<Step.SuccessPage stepName="success-page" subscriptionTypes={["RETAIL_NEWSLETTER"]} userEmail={email} />
			</>
		);
	}

	protected onStep(target: string, withEvent: boolean): void {
		if (target === "success-page") {
			this.sendLead()
				.then(() => {
					super.onStep(target, false);
				})
				.catch((error: Error) => {
					// TODO: Hibakezelés
					logError(error);
				});
		} else {
			super.onStep(target, withEvent);
		}
	}

	protected getLeadData(): LeadRequest<TRequest, TResponse> {
		const data = super.getLeadData();
		data.request.preferredProduct = "PENSION";

		return data;
	}

	protected getAutoresponderName(): string {
		return "autoresponder-pension-calculator";
	}

	protected getAutoresponderFields(): Record<string, any> {
		const {
			values: { lastName, firstName },
		} = this.state;

		return {
			lastName,
			firstName,
		};
	}

	protected getProductType(): ProductType {
		return "SAVINGS_INSURANCE";
	}

	protected getComponentName(): string {
		return "PensionSavingLeadForm";
	}
}
